import { FC } from 'react';
import TetherIcon from '@/features/rewards/Tabs/RedeemTab/components/TetherIcon/TetherIcon';
import { formatValue } from '@/pages/agentDashboard/utils/utils';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import PhenomChip from '@/components/PhenomChip/PhenomChip';

interface DashBoardStatCardProps {
  title: string;
  showIcon?: boolean;
  usePhenomIcon?: boolean;
  total?: number | string;
  isLoading?: boolean;
  useGreyIcon?: boolean;
}
const DashBoardStatCard: FC<DashBoardStatCardProps> = ({
  title,
  showIcon = false,
  total,
  isLoading = false,
  usePhenomIcon = false,
  useGreyIcon = false,
}) => {
  return (
    <div className="flex h-15 w-full flex-col items-center justify-center rounded-2xl bg-ph-white-3 py-2">
      <span className="w-[75%] overflow-hidden text-ellipsis whitespace-nowrap text-center text-xs font-bold text-ph-white-30 md:w-full">
        {title}
      </span>
      <div className="flex items-center gap-1">
        {showIcon && !usePhenomIcon && <TetherIcon useGreyIcon={useGreyIcon} width="20" height="20" />}
        {usePhenomIcon && <PhenomChip width="20" height="20" />}
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <span className="text-base font-extrabold text-white md:text-xl">
            {total !== undefined ? formatValue(total) : '0'}
          </span>
        )}
      </div>
    </div>
  );
};

export default DashBoardStatCard;
